// extracted by mini-css-extract-plugin
export default {"user-link":"MGe0a","userLink":"MGe0a","link-banned":"_3L5dm","linkBanned":"_3L5dm"};